import React, { useCallback, useState } from "react";
import "./chathistory.scss";
import Chathistorytable from "./chathistorytable";
import Chatbot from "../../../components/chatbot";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getChatByUser, getChatUser } from "../../../store/slices/projectSlice";

export default function Chathistory() {
  const [userChatById, setUserChatById] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const { selectedProject } = useSelector((state) => state.project);
  const handleGetHistory = useCallback(
    (page, limit, search) => {
      const body = {
        payload: {
          project_id: selectedProject?.id,
        },
        page: page,
        limit: limit,
        name: search,
      };
      dispatch(getChatUser(body))
        .unwrap()
        .then((res) => {
          if (!res?.data?.success) return;
          setTotalData(res?.data?.total_data);
        });
    },
    [dispatch, selectedProject]
  );
  useEffect(() => {
    handleGetHistory(1, 10, "");
  }, [handleGetHistory]);

  const [selectedUser, setSelectedUser] = useState(null);

  const handleOnClickChat = (data) => {
    setSelectedUser(data);
    let body = {
      payload: {
        session_id: data?.session_id,
        project_id: selectedProject?.id,
      },
      route:
        data?.session_type === "public" ? "chat-pub-history" : "chat-history",
    };
    dispatch(getChatByUser(body))
      .unwrap()
      .then((res) => {
        setUserChatById(res?.data?.data);
      });
  };
  return (
    <div className="chat-history-all-contnet-alignment">
      <div className="flex-box">
        <div className="flex-box-items">
          <Chathistorytable
            handleOnClickChat={handleOnClickChat}
            totalData={totalData}
            itemsPerPage={10}
            currentPage={currentPage}
            handleApiCall={handleGetHistory}
            setCurrentPage={setCurrentPage}
          />
        </div>
        <div className="flex-box-items">
          <Chatbot userChatById={userChatById} selectedUser={selectedUser} />
        </div>
      </div>
    </div>
  );
}
